// @react-functional

import React from 'react';
import { LoginModal } from './LoginModal';
import { useModal } from '../components/modal/useModal';

export const useLoginModal = () => {
  const { openModal } = useModal<{ source: string }>(
    ({ customProps, ...modalProps }) => (
      <LoginModal source={customProps.source} {...modalProps} />
    ),
  );

  return { openLoginModal: openModal };
};
